module.exports = __webpack_public_path__ + "BebasNeue-webfont.0fd7856401d0a55db2df.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/assets/fonts/BebasNeue-webfont.svg
// module id = ../../../../../src/assets/fonts/BebasNeue-webfont.svg
// module chunks = styles